<h1 mat-dialog-title>{{isEdit ? 'Edit Co-branding' : 'Add Co-branding'}}</h1>

<div mat-dialog-content>
  <form [formGroup]="form" class="form">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>
      <mat-form-field appearance="outline" class="url-field">
        <mat-label>URL</mat-label>
        <input matInput formControlName="url">
        <span matSuffix>.wallit.app</span>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="fullwidth">
      <mat-label>Tagline</mat-label>
      <input matInput formControlName="tagline">
    </mat-form-field>

    <div class="row">
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Primary Color</mat-label>
          <input matInput formControlName="primary" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('primary')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Secondary Color</mat-label>
          <input matInput formControlName="secondary" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('secondary')?.value"></span>
      </div>
    </div>

    <div class="row">
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Tertiary Color</mat-label>
          <input matInput formControlName="wallitTertiaryColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitTertiaryColor')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Gradient SW Color</mat-label>
          <input matInput formControlName="wallitGradientSWColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitGradientSWColor')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Gradient NE Color</mat-label>
          <input matInput formControlName="wallitGradientNEColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitGradientNEColor')?.value"></span>
      </div>
    </div>

    <div class="file-field">
      <label class="file-label">Logo on Light</label>
      <input type="file" (change)="onFileChange($event, 'logo')">
      <img *ngIf="logoPreview" [src]="logoPreview" alt="logo preview" class="preview">
    </div>

    <div class="file-field">
      <label class="file-label">Logo on Dark</label>
      <input type="file" (change)="onFileChange($event, 'light')">
      <img *ngIf="lightLogoPreview" [src]="lightLogoPreview" alt="light logo preview" class="preview">
    </div>

    <div class="file-field">
      <label class="file-label">Horizontal Logo on Light</label>
      <input type="file" (change)="onFileChange($event, 'horizontalLight')">
      <img *ngIf="horizontalLightLogoPreview" [src]="horizontalLightLogoPreview" alt="horizontal light logo preview" class="preview">
    </div>

    <div class="file-field">
      <label class="file-label">Horizontal Logo on Dark</label>
      <input type="file" (change)="onFileChange($event, 'horizontal')">
      <img *ngIf="horizontalLogoPreview" [src]="horizontalLogoPreview" alt="horizontal logo preview" class="preview">
    </div>

    <mat-slide-toggle formControlName="signupDisabled">Signup Disabled</mat-slide-toggle>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Invite Email Mode</mat-label>
        <mat-select formControlName="inviteEmailMode">
          <mat-option value="web">Web</mat-option>
          <mat-option value="app">App</mat-option>
        </mat-select>
        <mat-hint>App mode is used only when both the download URL and QR image are available.</mat-hint>
      </mat-form-field>
    </div>

    <div *ngIf="shouldShowInviteEmailAppFields">
      <mat-form-field appearance="outline" class="fullwidth">
        <mat-label>Invite App Download URL</mat-label>
        <input matInput formControlName="inviteEmailDownloadUrl">
        <mat-hint>Invites fall back to the current web email until both app fields are saved.</mat-hint>
      </mat-form-field>

      <div class="file-field">
        <label class="file-label">Invite App QR Image</label>
        <input type="file" (change)="onFileChange($event, 'inviteQr')">
        <img *ngIf="inviteQrPreview" [src]="inviteQrPreview" alt="invite QR preview" class="preview">
      </div>

      <div class="error" *ngIf="shouldShowInviteEmailFallbackHelper">
        App invites will keep using the current web email until both the download URL and QR image are present.
      </div>
    </div>

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Config JSON</mat-label>
      <app-json formControlName="configjson" baseTable="partners" fieldHint="configjson"></app-json>
    </mat-form-field>

    <div class="bands" *ngIf="rewardsInBands.length">
      <h3>Rewards & Products in Bands</h3>
      <div class="band-row" *ngFor="let reward of rewardsInBands">
        <div class="band-title">{{reward.title}}</div>
        <div class="band-value">{{reward.reward}}</div>
      </div>
    </div>

    <div class="error" *ngIf="invalidField">{{invalidField}}</div>
  </form>
</div>

<div class="buttons" mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
  <button mat-button (click)="cancel()">Cancel</button>
</div>
